"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoSuchElementException;

/**
 * @param {string=} message Optional message
 * @extends {Error}
 * @constructor
 * @private
 */
function NoSuchElementException(message) {
  this.message = message || '';
}

;
NoSuchElementException.prototype = new Error();
/**
 * @type {string}
 */

NoSuchElementException.prototype.name = 'NoSuchElementException';